import { axiosV2 } from "config/@axios";
import {
  SET_POLICIE_DATA,
  SET_UNCONFIRMED_POLICIE_DATA
} from "./policieActions";
import { hostname } from "config/environment";

export const SELECT_ALL = "uiActions::SelectAll";
export const SELECT_SINGLE = "uiActions::SelectSingle";
export const SELECT_RANGE = "uiActions::SelectRange";

export const RESET_PAGINATION = "uiActions::resetPagination";

export const REMOVE_SNACKBAR = "uiActions::removeSnackbar";
export const ADD_SNACKBAR = "uiActions::addSnackbar";
export const CHANGE_FOLDER = "uiActions::changeFolder";
export const CHANGE_PAGE = "uiActions::changePage";
export const CHANGE_QUERY = "uiActions::changeQuery";

export const SET_LOADING = "uiAction::setLoading";
export const SET_DELETING_MESSAGES_IDS = "uiAction::setDeletingMessagesIds";

export const SET_LISTING_TYPE = "uiAction::setListingType";

export const SET_THEME = "uiAction::setTheme";
export const SET_THEME_ERROR_MESSAGE = "uiAction::setThemeErrorMessage";
export const SET_UNREAD_STATUS = "uiAction::setUnreadStatus";
export const SET_SORT = "uiAction::setSort";
export const RESET_THEME_ERRORS = "uiAction::resetThemeErrors";

export const INBOX_NEW_MESSAGES_RECEIVED = "uiAction::inboxNewMessagesReceived";
export const INBOX_NEW_MESSAGES_CLEAR = "uiAction::inboxNewMessagesClear";
export const INBOX_NEW_MESSAGES_HANDLED = "uiAction::inboxNewMessagesHandled";

export const selectAll =
  (isSelected, stateKey = "messages") =>
  (dispatch, getState) => {
    const { entities } = getState();
    let list = entities[stateKey].allIds;

    if (stateKey === "quarantines") {
      list = entities[stateKey].allIds.filter(
        id => !entities[stateKey].byId[id]?.deleted
      );
    }

    dispatch({
      type: SELECT_ALL,
      payload: {
        isSelected,
        list,
        stateKey
      }
    });
  };

export const selectRange =
  (selectedId, isSelected, stateKey = "messages") =>
  (dispatch, getState) => {
    const { entities, ui } = getState();
    let list = entities[stateKey].allIds;
    const lastId = ui.selected[stateKey].lastId;

    list = entities[stateKey].allIds.filter(
      id => !entities[stateKey].byId[id]?.deleted
    );

    const lastIdIndex = list.indexOf(lastId);
    const selectedIdIndex = list.indexOf(selectedId);

    let start = lastIdIndex;
    let end = selectedIdIndex;

    if (lastIdIndex > selectedIdIndex) {
      start = selectedIdIndex;
      end = lastIdIndex;
    }

    if (start < 0) {
      start = selectedIdIndex;
      end = selectedIdIndex;
    }

    list = list.slice(start, end + 1);

    dispatch({
      type: SELECT_RANGE,
      payload: {
        isSelected,
        list,
        stateKey,
        selectedId
      }
    });
  };

export const selectSingle = (id, isSelected, stateKey = "messages") => ({
  type: SELECT_SINGLE,
  payload: {
    id,
    isSelected,
    stateKey
  }
});

export const resetPagination = () => ({
  type: RESET_PAGINATION
});

export const removeSnackbar = id => ({
  type: REMOVE_SNACKBAR,
  payload: {
    id
  }
});

export const changeFolder = ({ folder }) => ({
  type: CHANGE_FOLDER,
  payload: {
    folder
  }
});

export const changeQuery = payload => ({
  type: CHANGE_QUERY,
  payload
});

export const setUnread = payload => ({
  type: SET_UNREAD_STATUS,
  payload
});

export const addSnackbar = ({
  message,
  actionButton = null,
  status = "success",
  id = null,
  autoHide = true,
  placement = "bottom"
}) => {
  const obj = { message, status };
  if (actionButton) {
    obj["actionButton"] = actionButton;
  }
  if (id) {
    obj["id"] = id;
  }
  if (autoHide !== true) {
    obj["autoHide"] = autoHide;
  }
  if (placement !== "bottom") {
    obj["placement"] = placement;
  }

  return {
    type: ADD_SNACKBAR,
    payload: obj
  };
};

export const setLoading = isLoading => ({
  type: SET_LOADING,
  payload: {
    isLoading
  }
});

export const setDeletingMessagesIds = ids => ({
  type: SET_DELETING_MESSAGES_IDS,
  payload: {
    ids
  }
});

export const setListingType = text => ({
  type: SET_LISTING_TYPE,
  payload: {
    text
  }
});

export const resetFailed = () => ({
  type: RESET_THEME_ERRORS
});

export const setTheme =
  (email = "", onSuccess = () => {}) =>
  dispatch => {
    const url = email ? `login?email=${email}` : `login?host=${hostname}`;

    return axiosV2
      .get(url)
      .then(response => {
        const {
          logo,
          alternative_logo,
          background,
          title,
          main,
          domains,
          language = "en",
          login_theme,
          pw_change_url,
          logout_url,
          favicon,
          light,
          dark,
          developer_logo,
          developer_url,
          knowledge_base,
          powered_by,
          qr_login,
          logo_size,
          mc_banner_logo,
          mc_banner_alternative_logo,
          mc_banner_link,
          mc_login_banner_link,
          mc_login_banner_logo,
          logo_link,
          mc_meta_desription
        } = response.data;

        dispatch({
          type: SET_POLICIE_DATA,
          payload: response.data?.policies ? response.data?.policies : []
        });
        dispatch({
          type: SET_UNCONFIRMED_POLICIE_DATA,
          payload: response.data?.unconfirmed_policies
            ? response.data?.unconfirmed_policies
            : []
        });

        dispatch({
          type: SET_THEME,
          payload: {
            logo,
            darkLogo: alternative_logo,
            background,
            title,
            main,
            domains,
            language,
            login_theme,
            pw_change_url,
            logout_url,
            favicon,
            light,
            dark,
            knowledge_base,
            developer_logo,
            developer_url,
            powered_by,
            qr_login,
            logo_size,
            banner: mc_banner_logo,
            darkBanner: mc_banner_alternative_logo,
            bannerLink: mc_banner_link,
            mc_login_banner_link,
            mc_login_banner_logo,
            logoLink: logo_link,
            metaDescription: mc_meta_desription
          }
        });
        onSuccess();
      })
      .catch(err => {
        err.response?.status !== 401 &&
          dispatch({
            type: SET_THEME_ERROR_MESSAGE,
            payload: err.errorMessage
          });
      });
  };

export const setSort = (sort = {}) => ({
  type: SET_SORT,
  payload: {
    sort
  }
});

export const inboxNewMessagesReceived = message => ({
  type: INBOX_NEW_MESSAGES_RECEIVED,
  payload: message
});

export const inboxNewMessagesClear = () => ({
  type: INBOX_NEW_MESSAGES_CLEAR
});

export const inboxNewMessagesHandled = messages => ({
  type: INBOX_NEW_MESSAGES_HANDLED,
  payload: {
    messages: Array.isArray(messages) ? messages : [messages]
  }
});
